import { UserProfile } from 'api/account/models/UserProfile';
import { CatalogMaintenanceContractsSearchCriteria } from 'api/catalog/models/CatalogMaintenanceContractsSearchCriteria';
import { CatalogSupplierSearchCriteria } from 'api/catalog/models/CatalogSupplierSearchCriteria';
import MaintenanceContractsService from 'api/contracts/maintenanceContract/MaintenanceContractsService';
import MaintenanceContractTypesService from 'api/maintenanceContractTypes/MaintenanceContractTypesService';
import SuppliersService from 'api/suppliers/SuppliersService';
import UsersService from 'api/users/UsersService';
import { VehicleMaintenanceStates } from 'api/vehicleMaintenances/enums/VehicleMaintenanceStates';
import { VehicleMaintenanceDto } from 'api/vehicleMaintenances/models/VehicleMaintenanceDto';
import VehicleMaintenancesService from 'api/vehicleMaintenances/VehicleMaintenancesService';
import VehiclesService from 'api/vehicles/VehiclesService';
import Button from 'common/components/button/Button';
import FileSelector from 'common/components/fileSelector/FileSelector';
import FormItem from 'common/components/formItem/FormItem';
import InputController from 'common/components/input/InputController';
import InputResizable from 'common/components/input/InputResizable';
import InputError from 'common/components/inputError/InputError';
import InputGroup from 'common/components/inputGroup/InputGroup';
import InputGroupController from 'common/components/inputGroup/InputGroupController';
import Label from 'common/components/label/Label';
import QuestionYesNo from 'common/components/questionYesNo/QuestionYesNo';
import SelectController from 'common/components/select/SelectController';
import CustomFile from 'common/models/CustomFile';
import Loading from 'common/services/Loading';
import Logger from 'common/services/Logger';
import Utils from 'common/services/Utils';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import { DATE_FORMAT_DEFAUT, DEFAULT_INPUT_RULES_WITH_REQUIRED, LOGGER_LOG_TYPE, removeAccents, SEGMENT_FEATURES } from 'Config';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { useForm, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { Reducers } from 'store/types';
import IconBack from 'assets/svg/Arrow-grey.svg';
import styles from './MaintenanceScreen.module.scss';
import InputGroupDate from 'common/components/inputGroupDate/InputGroupDate';
import DateWithHour from 'common/components/dateWithHour/DateWithHour';
import { FaInfoCircle } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';
import DateTimePickerControllerNew from 'common/components/dateTimePicker/DateTimePickerControllerNew';
import { VehicleDto } from 'api/vehicles/models/VehicleDto';
import InputInfoWarning from 'common/components/inputInfoWarning/InputInfoWarning';
import TrackingService from 'api/tracking/TrackingService';
import { TrackingProvider } from 'api/tracking/enums/TrackingProvider';
import { ReminderCategoriesDto } from 'api/reminderCategories/models/ReminderCategoriesDto';
import ReminderCategoriesService from 'api/reminderCategories/ReminderCategoriesService';
import { ReminderTriggersDto } from 'api/reminders/models/ReminderDto';
import { UsersSelectItemDto } from 'api/users/models/UserDto';
import ReminderTriggerForm from '../../carReminderTab/components/reminderTriggerForm/ReminderTriggerForm';
import SendMaintenanceAttachmentsEmailModal from './MaintenanceAttachmentsSendEmailModal/SendMaintenanceAttachmentsEmailModal';
import TimeLine, { TimeLineItem } from 'common/components/timeLine/TimeLine';
import Select from 'common/components/select/Select';
import { VehicleMaintenanceComponentDto } from 'api/vehicleMaintenances/models/VehicleMaintenanceDto';

export type Props = {
    item?: VehicleMaintenanceDto | null;
    isDetails: boolean;
    onBackList: () => void;
    onItemDetails: (state: boolean) => void;
    onSubmitDone: (itemId: string) => void;
    isModal?: boolean;
    vehicleId?: string | null;
    editable: boolean;
    titleHeader: string | undefined;
} & React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const MaintenanceScreen = ({ item, editable, isDetails, onBackList, onItemDetails, onSubmitDone, titleHeader, isModal, vehicleId: propVehicleId, ...props }: Props) => {
    const { t } = useTranslation();
    const { addToast } = useToasts();
    const history = useHistory();
    // eslint-disable-next-line
    let { vehicleId: routeVehicleId, itemType, itemId, tabId, type } = useParams<{ vehicleId: string, itemType: string, itemId: string, tabId: string, type: string }>();
    const vehicleId = propVehicleId ? propVehicleId : routeVehicleId;
    const form = useForm<VehicleMaintenanceDto>({ shouldUnregister: false });

    const { handleSubmit, setValue, getValues, errors, reset } = form;

    const [vehicleOptions, setVehicleOptions] = useState<SelectValueLabel[]>([]);
    const [itemToRemove, setItemToRemove] = useState<VehicleMaintenanceDto>();
    const [dialogDeleteItemIsOpen, setDialogDeleteItemIsOpen] = React.useState(false);
    const [maintenance, setMaintenance] = useState<VehicleMaintenanceDto | null>(null);

    const [contractTypeOptions, setContractTypeOptions] = useState<SelectValueLabel[]>([]);
    const [contractNumbersOptions, setContractNumbersOptions] = useState<SelectValueLabel[]>([]);
    const [statesOptions, setStatesOptions] = useState<SelectValueLabel[]>([]);
    const [responsibleOptions, setResponsibleOptions] = useState<SelectValueLabel[]>([]);
    const [supplierOptions, setSupplierOptions] = useState<SelectValueLabel[]>([]);

    const [vehicle, setVehicle] = useState<VehicleDto | undefined>(undefined);
    const [inputKmsBelowCurrentVehicleKms, setInputKmsBelowCurrentVehicleKms] = useState<boolean>(false);

    const [state, setState] = useState<string>();
    const [savedFiles, setSavedFiles] = useState<CustomFile[]>([]);

    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const hasVehicleMaintenancesWritePolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_VEHICLE_MAINTENANCES_WRITE']);
    const hasReadGPSKmsPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_GPS_KMS_READ']);
    const hasRemindendersCreatePolicy = UsersService.hasPolicies(userProfile?.policies ?? [], ['SETTINGUP_REMINDER_WRITE']);

    const [currentKmsGps, setCurrentKmsGps] = useState<number | null>(null);
    const [showSendMaintenanceAttachmentsEmailModal, setShowSendMaintenanceAttachmentsEmailModal] = useState<boolean>(false);
    const [showAppointmentSection, setShowAppointmentSection] = useState<boolean>(false);

    const [sendEmailHistory, setSendEmailHistory] = useState<TimeLineItem[]>([]);

    // ----------------------------- REMINDERS ----------------------------------------------
    const REMINDER_VEHICLE_TYPE = 'VEHICLE';
    const REMINDER_MAINTENANCE_TYPE = 'MAINTENANCE';
    const [criteriaOptions, setCriteriaOptions] = useState<SelectValueLabel[]>([
        { value: 'DATE', label: t('reminders.notifications.criteria.DATE') }]);

    const [measureOptions, setMeasureOptions] = useState<SelectValueLabel[]>([
        { value: 'HOURS', label: t('reminders.notifications.measure.HOURS') },
        { value: 'DAY', label: t('reminders.notifications.measure.DAY') },
        { value: 'YEAR', label: t('reminders.notifications.measure.YEAR') },
        { value: 'MONTH', label: t('reminders.notifications.measure.MONTH') },
        { value: 'WEEK', label: t('reminders.notifications.measure.WEEK') }]);
    const [reminderCategory, setReminderCategory] = useState<ReminderCategoriesDto | undefined>();

    const [responsablesOptions, setResponsablesOptions] = useState<SelectValueLabel[]>([]);
    const [componentsCatalog, setComponentsCatalog] = useState<SelectValueLabel[]>([]);
    const [componentsOptions, setComponentsOptions] = useState<SelectValueLabel[]>([]);

    const componentsFieldArray = useFieldArray<VehicleMaintenanceComponentDto>({
        control: form.control,
        name: 'components',
        keyName: 'formId' as any
    });
    // ---------------------------------------------------------------------------------------



    const getData = async () => {
        try {
            Loading.show();
            setValue('vehicleId', vehicleId);

            const [contractTypesOrig, responsibles, suppliers, responsables, category, componentsCatalogData] = await Promise.all([
                MaintenanceContractTypesService.catalog(),
                UsersService.catalog(),
                SuppliersService.catalog({ typeName: 'MAINTENANCE' } as CatalogSupplierSearchCriteria),
                UsersService.getAllForCompany(),
                hasRemindendersCreatePolicy ? ReminderCategoriesService.getByLabel(REMINDER_MAINTENANCE_TYPE) : null,
                VehicleMaintenancesService.getComponentsCatalog()
            ]);

            setComponentsCatalog(componentsCatalogData || []);

            const contractTypes = contractTypesOrig.map(x => ({ ...x, label: x.isSystem ? t(`common.maintenance_contract_type.${x.label}` as any) : x.label }));
            const contractTypesOrdered = Utils.sortAlphabetically(contractTypes);
            setContractTypeOptions(contractTypesOrdered);

            setResponsibleOptions((responsibles || []).map((x: SelectValueLabel) => ({ value: x.value || '', label: x.label || '' })));

            setSupplierOptions(suppliers);

            const vehicleMaintenanceStates = Object.keys(VehicleMaintenanceStates).filter(key => isNaN(Number(key)));

            const states: SelectValueLabel[] = vehicleMaintenanceStates.map(vehicleMaintenanceState => { return { value: vehicleMaintenanceState, label: t(`maintenances.states.${vehicleMaintenanceState}` as any) } });
            setStatesOptions(Utils.sortAlphabetically(states));

            if (category) {
                setReminderCategory(category);
            }

            const __responsablesOptions = (responsables || []).map((x: UsersSelectItemDto) => ({ value: x.email || '', label: x.realName ? `${x.realName} (${x.email})` : x.email || '' }));
            setResponsablesOptions(__responsablesOptions);


            let vehicleIdVerified = vehicleId;
            let resultVehicleId: string | undefined = undefined;
            if (item && item.id) {
                const result = await VehicleMaintenancesService.getById(item.id);
                if (result === undefined) {
                    addToast(t('common.messages.error_load_info'), { appearance: 'error' });
                    Logger.error(LOGGER_LOG_TYPE.MAINTENANCES, `Couldn't get the maintenance with id: ${item.id}`);
                    onBackList();
                }
                resultVehicleId = result.vehicleId;
                vehicleIdVerified = !vehicleIdVerified ? (result.vehicleId ?? '') : vehicleIdVerified;
                if (!!result.adviseMaintenanceDate) {
                    getContactNumbersByDate(result.adviseMaintenanceDate, resultVehicleId);
                } else {
                    getContractsByVehicle(resultVehicleId);
                }

                if (result && result.triggers?.length > 0) {
                    result.triggers = result.triggers.map((x: ReminderTriggersDto) => {
                        const __contacts = x.contacts?.filter(z => !responsables.find((y: UsersSelectItemDto) => { return y.email === z.email }));
                        if (__contacts) {
                            __contacts.forEach(c => {
                                if (!__responsablesOptions.find((y: SelectValueLabel) => { return y.value === c.email })) {
                                    __responsablesOptions.push({ value: c.email || '', label: c.email || '' });
                                }
                            });
                        }
                        return {
                            ...x,
                            firstDate: x.firstDate ? new Date(x.firstDate) : null,
                            stopDate: x.stopDate ? new Date(x.stopDate) : null,
                        };
                    });
                }
                setResponsablesOptions(__responsablesOptions);
                setValues(result);


                const emailHistoriesData = await VehicleMaintenancesService.getMaintenanceEmailHistory(item.id);
                if (emailHistoriesData && Array.isArray(emailHistoriesData)) {
                    const timeLineItems = emailHistoriesData.map(history => ({
                        email_to: history.emailTo,
                        email_cc: history.emailCC,
                        subject: history.subject,
                        message: history.message,
                        createdDate: history.createdDate ? new Date(history.createdDate) : undefined,
                        userName: history.userCreatedName,
                        userPhotoUrl: history.userPhotoUrl,
                        refundAttachments: (history.attachments || []).map((a: any) => ({
                            name: a.fileName,
                            url: a.url
                        })) as CustomFile[]
                    }));
                    setSendEmailHistory(timeLineItems as any);

                }
            }
            else {
                getContactNumbersByDate();
            }

            if (Utils.isStringNullOrEmpty(vehicleId)) {
                const vehicles = await VehiclesService.catalog({ vehicleId: resultVehicleId });
                setVehicleOptions(vehicles);
            }

            if (!Utils.isStringNullOrEmpty(vehicleIdVerified)) {
                getVehicle(vehicleIdVerified);
            }

            Loading.hide();

        } catch (error) {
            Loading.hide();
            Logger.error(LOGGER_LOG_TYPE.MAINTENANCES, `Couldn't get information to create maintenance`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const getGpsKms = async () => {
        if (vehicle && vehicle.id && vehicle.companyTrackingProvider && vehicle?.companyTrackingProvider !== TrackingProvider.NONE && vehicle.trackingDeviceId) {
            try {
                const positionResult = await TrackingService.getGpsVehiclesPosition([vehicle.id]);
                if (positionResult && positionResult.length > 0) {
                    setCurrentKmsGps(positionResult[0]?.km ?? null);
                }
            } catch (error) {
                Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't get vehicle gps kms`, error);
                addToast(t('common.messages.error_load_info'), { appearance: 'error' });
            }
        }
    }

    const getContractsByVehicle = async (vehicleId?: string) => {
        try {
            const results = await MaintenanceContractsService.catalog({ vehicleId: !!vehicleId ? vehicleId : form.getValues('vehicleId') } as CatalogMaintenanceContractsSearchCriteria);
            setContractNumbersOptions(results);
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.MAINTENANCES, `Couldn't get contracts of vehicle`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const getVehiclesByContract = async () => {
        try {
            const results = await VehiclesService.getByMaintenanceContractId({ id: form.getValues('maintenanceContractsId') } as CatalogMaintenanceContractsSearchCriteria);
            setVehicleOptions(results);
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.MAINTENANCES, `Couldn't get vehicles of contract`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const getContactNumbersByDate = async (date?: Date, vehicleIdAux?: string) => {
        const contractNumbers = await MaintenanceContractsService.catalog({ vehicleId: !!vehicleIdAux ? vehicleIdAux : vehicleId, date } as CatalogMaintenanceContractsSearchCriteria);
        if (!contractNumbers.find(x => x.value == getValues('maintenanceContractsId'))) {
            setValue('maintenanceContractsId', null);
        }
        setContractNumbersOptions(contractNumbers);
    }

    const setValues = (values: VehicleMaintenanceDto) => {
        values.adviseMaintenanceDate = values.adviseMaintenanceDate ? new Date(values.adviseMaintenanceDate) : undefined;
        values.expectedDate = values.expectedDate ? new Date(values.expectedDate) : undefined;
        values.expectedEndDate = values.expectedEndDate ? new Date(values.expectedEndDate) : undefined;
        values.maintenanceDate = values.maintenanceDate ? new Date(values.maintenanceDate) : undefined;
        values.paymentDate = values.paymentDate ? new Date(values.paymentDate) : undefined;
        reset(values);
        setValuesFiles(values.attachments);
        setMaintenance(values);
    }

    const onSubmit = async (model: VehicleMaintenanceDto) => {
        try {

            // Validate maintenance period dates
            if (model.expectedDate && !model.expectedEndDate) {
                addToast(t('maintenances.maintenance_end_date_required'), { appearance: 'warning' });
                return;
            }
            if (!model.expectedDate && model.expectedEndDate) {
                addToast(t('maintenances.maintenance_start_date_required'), { appearance: 'warning' });
                return;
            }
            if (model.expectedDate && model.expectedEndDate && new Date(model.expectedDate).getTime() > new Date(model.expectedEndDate).getTime()) {
                addToast(t('maintenances.maintenance_end_date_before_start'), { appearance: 'warning' });
                return;
            }

            Loading.show();

            if (model.maintenanceContractsId) {
                model.cost = null;
            }

            prepareFilesToSubmit();

            const triggers = (model.triggers ?? []);
            const hasAnyTriggers = triggers.length > 0;

            const reminder =
            {
                designation: model.description,
                type: REMINDER_VEHICLE_TYPE,
                categoryId: reminderCategory ? reminderCategory.id : null,
                active: true,
                vehicleId: model.vehicleId,
                triggers: triggers,
            }

            const tempModel = {
                ...model,
                reminder: hasAnyTriggers ? reminder : null
            };

            if (tempModel.id || maintenance?.id) {
                if (!tempModel.id && maintenance) {
                    tempModel.id = maintenance.id;
                }
                await VehicleMaintenancesService.update(tempModel, model.attachments ?? []);
            } else {
                itemId = await VehicleMaintenancesService.create(tempModel, model.attachments ?? []);
                setMaintenance(await VehicleMaintenancesService.getById(itemId));
            }

            addToast(t('common.messages.record_save_success'), { appearance: 'success' });
            Loading.hide();
            onSubmitDone(itemId);

            getData();
        } catch (error) {
            addToast(t('common.messages.record_save_error'), { appearance: 'error' });
            Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't update the maintenance with id: ${model.id}`, error);
            arrangeFilesAfterSubmit();
            Loading.hide();
        }
    }

    const showRemoveItemDialog = (_item: VehicleMaintenanceDto) => {
        setItemToRemove(_item);
        setDialogDeleteItemIsOpen(true);
    };

    const removeItem = async () => {
        setDialogDeleteItemIsOpen(false);
        if (!!itemToRemove) {
            try {
                Loading.show();
                await VehicleMaintenancesService.remove(itemToRemove);
                addToast(t('common.messages.record_delete_success'), { appearance: 'success' });
                onBackList();
                Loading.hide();
            } catch (error) {
                addToast(t('common.messages.record_delete_error'), { appearance: 'error' });
                Loading.hide();
            }
        }
    };

    const arrangeFilesAfterSubmit = () => {
        setValuesFiles(savedFiles);
    }

    const prepareFilesToSubmit = () => {
        setValuesFiles((getValues('attachments') ?? []).filter(x => !x.id));
    }

    const setValuesFiles = (files: CustomFile[]) => {
        setValue('attachments', files);
        setSavedFiles(files?.filter(x => x.id));
    }

    const onRemoveFile = (file: CustomFile) => {
        if (file.id) {
            const arr = [...(getValues('attachmentsToRemove') || []), file.id];
            setValue('attachmentsToRemove', arr);
        }
    }

    useEffect(() => {
        if (vehicle) {
            // current kms from tracking
            if (!isDetails) {
                getGpsKms();
            }
        }
    }, [vehicle, isDetails]);


    useEffect(() => {
        getData().catch(console.error);
    }, []);



    useEffect(() => {
        if (maintenance) {
            const hasTriggers2 = maintenance.triggers?.some((t: any) => t.control === 2);
            if (maintenance.responsibleId || maintenance.expectedDate || hasTriggers2) {
                setShowAppointmentSection(true);
            }
        }
    }, [maintenance]);

    useEffect(() => {

        if (((!!type && type == 'new') || (!!itemType && itemType == 'new'))) {
            setKilometers();
            setHours();
        }
    }, [vehicle, form.watch('state')]);



    const renderButtons = () => {
        return (
            <>
                <div className={styles.buttonsContainer}>
                    <Button
                        preset={'secondary'}
                        type="button"
                        onClick={() => {
                            // setUseReminder(false);
                            if (!!maintenance) { reset(maintenance); }
                            onBackList()
                        }}
                        text={t('common.cancel')}
                    />
                    {isDetails && !isModal && editable && hasVehicleMaintenancesWritePolicy && maintenance?.active &&
                        <Button
                            type="button"
                            text={t('common.remove')}
                            preset={'danger'}
                            onClick={() => showRemoveItemDialog({ id: maintenance?.id } as VehicleMaintenanceDto)} />
                    }
                    {isDetails && !isModal && editable && hasVehicleMaintenancesWritePolicy && maintenance?.active &&
                        <Button
                            type={'button'}
                            text={t('common.edit')}
                            onClick={() => { onItemDetails(false) }}
                        />}
                    {(!isDetails || isModal) && hasVehicleMaintenancesWritePolicy &&
                        <Button
                            type={'submit'}
                            text={t('common.save')}
                        />}

                    <QuestionYesNo message={t('common.messages.remove_record')}
                        isVisible={dialogDeleteItemIsOpen}
                        onYes={() => removeItem()}
                        onNo={() => setDialogDeleteItemIsOpen(false)} />
                </div>
            </>
        );
    };

    const currentState = form.watch('state');

    const maintenanceContractId = form.watch('maintenanceContractsId');

    const changeVehicle = (data: SelectValueLabel) => {
        const vId = data ? data.value : null;
        setValue('vehicleId', vId);
        getVehicle(vId);
    }

    const canShowMaintenanceQuestionArea = () => {
        const stateIsPerform = currentState === VehicleMaintenanceStates.PERFORM;

        // In details mode, only show if there's actual appointment data
        if (isDetails && !isModal) {
            const hasTriggers2 = maintenance?.triggers?.some((t: any) => t.control === 2);
            return !!(maintenance?.responsibleId || maintenance?.expectedDate || hasTriggers2);
        }

        const valueToReturn = currentState && ((!maintenance && !stateIsPerform && !isDetails) ||
            (!!maintenance?.responsibleId || !!maintenance?.expectedDate) || !stateIsPerform);
        return valueToReturn;
    }

    const canShowAlertNotifications = () => {
        const stateIsPredicted = currentState === VehicleMaintenanceStates.PREDICTED;

        const valueToReturn = hasRemindendersCreatePolicy && currentState && ((!maintenance && stateIsPredicted && !isDetails) ||
            (!!maintenance?.adviseMaintenanceKilometers || !!maintenance?.adviseMaintenanceDate || !!maintenance?.adviseMaintenanceHours) ||
            stateIsPredicted);
        return valueToReturn;
    }

    const getVehicle = async (id?: string | null) => {
        try {
            const _vehicle = id ? await VehiclesService.getById(id) : undefined
            setVehicle(_vehicle);
            compareKms(_vehicle);

            const opts: SelectValueLabel[] = [
                { value: 'DATE', label: t('reminders.notifications.criteria.DATE') }
            ];
            if (_vehicle?.segmentFeatures?.includes('KM')) {
                opts.push({ value: 'KMS', label: t('reminders.notifications.criteria.KMS') });
            }
            if (_vehicle?.segmentFeatures?.includes('HOURS')) {
                opts.push({ value: 'HOURS', label: t('reminders.notifications.criteria.HOURS') });
            }
            setCriteriaOptions(opts);
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.MAINTENANCES, `Couldn't get vehicle data`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }


    const setKilometers = () => {
        if (vehicle && currentState === VehicleMaintenanceStates.PERFORM && showField(SEGMENT_FEATURES.KM)) {
            if (hasReadGPSKmsPolicy && currentKmsGps != null) {
                form.setValue('kilometers', currentKmsGps);
                return;
            }
            form.setValue('kilometers', vehicle?.currentKilometers);
            return;
        } else if (!showField(SEGMENT_FEATURES.KM) || !(currentState === VehicleMaintenanceStates.PERFORM)) {
            form.setValue('kilometers', undefined);
            return
        }
        form.setValue('kilometers', 0);
    }

    const setHours = () => {
        if (vehicle && currentState === VehicleMaintenanceStates.PERFORM && showField(SEGMENT_FEATURES.HOURS)) {
            form.setValue('hours', vehicle?.currentHours ?? undefined);
            return;
        }
        form.setValue('hours', undefined);
    }

    const compareKms = (_vehicle?: VehicleDto | undefined) => {
        if (form.watch('kilometers') && (_vehicle || vehicle) && (form.watch('kilometers') ?? 0) < (_vehicle?.currentKilometers ?? vehicle?.currentKilometers ?? 0)) {
            setInputKmsBelowCurrentVehicleKms(true);
            return;
        }
        setInputKmsBelowCurrentVehicleKms(false);
    }

    const showField = (feature: string) => {
        return (vehicle?.segmentFeatures?.findIndex(x => x == feature) ?? -1) >= 0;
    }

    // Components handling
    const getComponentsSelectedValues = (): SelectValueLabel[] => {
        return componentsFieldArray.fields.map(field => ({
            value: field.maintenanceComponentId || `new_${field.name?.toLowerCase().replace(/\s+/g, '_')}` || '',
            label: field.name || ''
        }));
    };

    const handleComponentsChange = (newValues: SelectValueLabel[]) => {
        const currentFields = componentsFieldArray.fields;
        const newValueIds = new Set(newValues.map(v => v.value));

        // Find removed items
        currentFields.forEach(field => {
            const fieldId = field.maintenanceComponentId || `new_${field.name?.toLowerCase().replace(/\s+/g, '_')}` || '';
            if (!newValueIds.has(fieldId)) {
                // Track for removal if it has an id (exists in DB)
                if (field.id) {
                    const toRemove = form.getValues('componentsToRemove') || [];
                    form.setValue('componentsToRemove', [...toRemove, field.id]);
                }
            }
        });

        // Clear all and re-add
        const indicesToRemove = currentFields.map((_, i) => i).reverse();
        indicesToRemove.forEach(i => componentsFieldArray.remove(i));

        // Add new values
        newValues.forEach(val => {
            const existingField = currentFields.find(f => {
                const fId = f.maintenanceComponentId || `new_${f.name?.toLowerCase().replace(/\s+/g, '_')}`;
                return fId === val.value || f.name === val.label;
            });

            if (existingField) {
                componentsFieldArray.append({
                    id: existingField.id,
                    maintenanceComponentId: existingField.maintenanceComponentId,
                    name: existingField.name,
                    isNew: existingField.isNew
                });
            } else {
                const isFromCatalog = componentsCatalog.some(c => c.value === val.value);
                if (isFromCatalog) {
                    componentsFieldArray.append({
                        maintenanceComponentId: val.value,
                        name: val.label,
                        isNew: false
                    });
                } else {
                    componentsFieldArray.append({
                        name: val.label,
                        isNew: true
                    });
                }
            }
        });
    };

    const handleCreateComponent = (name: string) => {
        const newOption: SelectValueLabel = {
            value: `new_${name.toLowerCase().replace(/\s+/g, '_')}`,
            label: name
        };
        setComponentsOptions(prev => [...prev, newOption]);

        componentsFieldArray.append({
            name: name,
            isNew: true
        });
    };

    // Initialize components options from catalog
    useEffect(() => {
        if (componentsCatalog && componentsCatalog.length > 0) {
            setComponentsOptions(componentsCatalog);
        }
    }, [componentsCatalog]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className={styles.fullHeight}>
                <div {...props} className={styles.fullHeight}>
                    <Row className={styles.fullHeight} style={{ margin: 0 }}>
                        <Col xs={12} sm={12} md={12} lg={8} xl={9}>
                            <div className={styles.content}>
                                {!isModal && titleHeader && <div className={styles.header}>
                                    <img src={IconBack} className={styles.icon} onClick={() => { if (!!maintenance) { reset(maintenance); } history.goBack() }} />
                                    {titleHeader}
                                    {(Boolean(maintenance) && !maintenance?.active) &&
                                        <span className={styles.messageDeleted}>{' - ' + t('maintenances.maintenance_deleted')}</span>
                                    }
                                </div>}
                                {!vehicleId && <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('vehicle.vehicle')} {'*'}</Label>
                                            <SelectController
                                                form={form as any}
                                                isDisabled={isDetails}
                                                placeholder={t('vehicle.vehicle')}
                                                name="vehicleId"
                                                options={vehicleOptions}
                                                rules={{ required: true }}
                                                onChangeSelect={(data: SelectValueLabel) => {
                                                    changeVehicle(data);
                                                    getContractsByVehicle();
                                                    getValues();
                                                }} />
                                            <InputError error={errors.vehicleId} />
                                        </FormItem>
                                    </Col>
                                </Row>}
                                <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('common.state')} {!isDetails || isModal ? '*' : ''}</Label>
                                            <SelectController
                                                form={form}
                                                name="state"
                                                placeholder={t('common.state')}
                                                isDisabled={isDetails && !isModal}
                                                options={statesOptions}
                                                rules={{ required: true }}
                                                isClearable={true}
                                                filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                onChangeSelect={(data: SelectValueLabel) => {
                                                    setValue('state', data ? data.value : null);
                                                    setValue('maintenanceDate', null);
                                                    setValue('maintenanceHour', null);
                                                    setMaintenance(maintenance ? { ...maintenance, maintenanceDate: undefined, maintenanceHour: undefined } : null);
                                                    setState(data?.value);
                                                    getGpsKms();
                                                    if (data?.value !== VehicleMaintenanceStates.PERFORM) {
                                                        handleComponentsChange([]);
                                                    }
                                                }}
                                            />
                                            <InputError error={errors.state} />
                                        </FormItem>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('common.type')} {!isDetails || isModal ? '*' : ''}</Label>
                                            <SelectController
                                                form={form}
                                                name="typeId"
                                                placeholder={t('common.types')}
                                                isDisabled={isDetails && !isModal}
                                                options={contractTypeOptions}
                                                rules={{ required: true }}
                                                isClearable={true}
                                                filterOption={(typeFO: any, input: any) => input ? removeAccents(typeFO.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                onChangeSelect={(data: SelectValueLabel) => {
                                                    setValue('typeId', data ? data.value : null);
                                                }}
                                            />
                                            <InputError error={errors.typeId} />
                                        </FormItem>
                                    </Col>
                                    {currentState === VehicleMaintenanceStates.PERFORM && <Col xs={12} md={6} lg={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('maintenances.components')}</Label>
                                            <Select
                                                isMulti
                                                isDisabled={isDetails && !isModal}
                                                options={componentsOptions}
                                                value={getComponentsSelectedValues()}
                                                onChange={(data: SelectValueLabel[]) => handleComponentsChange(data || [])}
                                                placeholder={isDetails && !isModal && getComponentsSelectedValues().length === 0
                                                    ? t('maintenances.no_components')
                                                    : t('maintenances.select_components')
                                                }
                                                isCreatable
                                                onCreateOption={handleCreateComponent}
                                                createOptionText={t('maintenances.add_component')}
                                                isClearable
                                            />
                                        </FormItem>
                                    </Col>}
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('common.description')} {!isDetails || isModal ? '*' : ''}</Label>
                                            <InputController
                                                name="description"
                                                form={form as any}
                                                autoComplete='off'
                                                placeholder={t('common.description')}
                                                disabled={isDetails && !isModal}
                                                rules={{ ...DEFAULT_INPUT_RULES_WITH_REQUIRED }}
                                                defaultValue={maintenance?.description}
                                            />
                                            <InputError error={errors.description} />
                                        </FormItem>
                                    </Col>
                                    {currentState === VehicleMaintenanceStates.PREDICTED && showField(SEGMENT_FEATURES.KM) && <Col xs={12} md={6} lg={8} className={styles.colXXL}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('maintenances.advise_kilometer_date')} {!isDetails || isModal ? '*' : ''}<FaInfoCircle className={styles.buttonOptions} data-tip={t('maintenances.advise_kilometer_date_info')} /> </Label>
                                            <InputGroupDate
                                                inputText={t('common.kms')}
                                                inputPlaceholder={t('common.kilometers')}
                                                inputName="adviseMaintenanceKilometers"
                                                form={form}
                                                inputDisabled={isDetails && !isModal}
                                                inputType="number"
                                                inputFormat="money"

                                                datePlaceholder={t('common.date')}
                                                onChangeDate={(date: Date) => {
                                                    setValue('adviseMaintenanceDate', date);
                                                    getContactNumbersByDate(date);
                                                }}
                                                dateSelected={(form.watch('adviseMaintenanceDate')) ? moment(form.getValues('adviseMaintenanceDate')).toDate() : undefined}
                                                dateFormat={DATE_FORMAT_DEFAUT}
                                                dateCustomInput={<InputGroup icon={<FaCalendarAlt />} removeInputBorderRadius={true} isClearable={true} onClear={() => { setValue('adviseMaintenanceDate', null) }} />}
                                                dateName="adviseMaintenanceDate"
                                                dateDisabled={isDetails && !isModal}
                                                inputRequired={!form.watch('adviseMaintenanceDate')}
                                                dateRequired={!form.watch('adviseMaintenanceKilometers')}
                                            />
                                            <InputError error={errors.adviseMaintenanceKilometers || errors.adviseMaintenanceDate} />
                                        </FormItem>
                                        <ReactTooltip />
                                    </Col>}
                                    {currentState === VehicleMaintenanceStates.PREDICTED && showField(SEGMENT_FEATURES.HOURS) && <Col xs={12} md={6} lg={4} className={styles.colXXL}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('maintenances.advise_hours')} {(!isDetails || isModal) && !showField(SEGMENT_FEATURES.KM) ? '*' : ''} <FaInfoCircle className={styles.buttonOptions} data-tip={t('maintenances.advise_hours_info')} /> </Label>
                                            <InputGroupController
                                                text={t('common.hours_symbol')}
                                                placeholder={t('common.hours')}
                                                name="adviseMaintenanceHours"
                                                form={form}
                                                disabled={isDetails && !isModal}
                                                type="number"
                                                format="number"
                                                rules={{ required: !showField(SEGMENT_FEATURES.KM) && !form.watch('adviseMaintenanceDate') }}
                                            />
                                            <InputError error={errors.adviseMaintenanceHours} />
                                        </FormItem>
                                        <ReactTooltip />
                                    </Col>}
                                    {currentState === VehicleMaintenanceStates.PREDICTED && !showField(SEGMENT_FEATURES.KM) && <Col xs={12} md={6} lg={4} className={styles.colXXL}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('maintenances.date_attributed')} {(!isDetails || isModal) && !showField(SEGMENT_FEATURES.HOURS) ? '*' : ''} <FaInfoCircle className={styles.buttonOptions} data-tip={t('maintenances.advise_date_info')} /> </Label>
                                            <DateTimePickerControllerNew
                                                form={form}
                                                placeholderText={t('common.date')}
                                                name="adviseMaintenanceDate"
                                                autoComplete='off'
                                                disabled={isDetails}
                                                rules={{ required: !showField(SEGMENT_FEATURES.HOURS) || !form.watch('adviseMaintenanceHours') }}
                                                isClearable={!isDetails}
                                            />
                                            <InputError error={errors.adviseMaintenanceDate} />
                                        </FormItem>
                                        <ReactTooltip />
                                    </Col>}
                                    {currentState === VehicleMaintenanceStates.PERFORM && showField(SEGMENT_FEATURES.KM) && <Col xs={12} md={6} lg={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('common.kilometers')}</Label>
                                            <InputGroupController
                                                text={t('common.kms')}
                                                placeholder={t('common.kilometers')}
                                                name="kilometers"
                                                form={form}
                                                disabled={isDetails && !isModal}
                                                type="number"
                                                format="money"
                                                onChange={() => compareKms()}
                                            />
                                            <InputError error={errors.kilometers} />
                                            {vehicle && !isDetails && vehicle?.currentKilometers ? <InputInfoWarning isWarning={inputKmsBelowCurrentVehicleKms} message={t((inputKmsBelowCurrentVehicleKms ? 'common.inserted_kms_below_current_kms' : 'common.insert_kms_below_current_kms'), { kms: Utils.numberFormatter(vehicle?.currentKilometers ?? 0) })} /> : null}
                                            {hasReadGPSKmsPolicy && vehicle && !isDetails && currentKmsGps != null && <InputInfoWarning isWarning={false} message={t('location.current_km', { kms: Utils.numberFormatter(currentKmsGps ?? 0) })} />}
                                        </FormItem>
                                    </Col>}
                                    {currentState === VehicleMaintenanceStates.PERFORM && showField(SEGMENT_FEATURES.HOURS) && <Col xs={12} md={6} lg={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('common.hours')}</Label>
                                            <InputGroupController
                                                text={t('common.hours_symbol')}
                                                placeholder={t('common.hours')}
                                                name="hours"
                                                form={form}
                                                disabled={isDetails && !isModal}
                                                type="number"
                                                format="number"
                                            />
                                            <InputError error={errors.hours} />
                                            {vehicle && !isDetails && vehicle?.currentHours ? <InputInfoWarning isWarning={(form.watch('hours') ?? 0) < (vehicle?.currentHours ?? 0)} message={t(((form.watch('hours') ?? 0) < (vehicle?.currentHours ?? 0) ? 'common.inserted_hours_below_current_hours' : 'common.insert_hours_below_current_hours'), { hours: Utils.numberFormatter(vehicle?.currentHours ?? 0) })} /> : null}
                                        </FormItem>
                                    </Col>}
                                    <Col xs={12} md={6} lg={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('common.supplier')}</Label>
                                            <SelectController
                                                form={form}
                                                name="supplierId"
                                                placeholder={t('common.supplier')}
                                                isDisabled={isDetails && !isModal}
                                                options={supplierOptions}
                                                isClearable={true}
                                                filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                onChangeSelect={(data: SelectValueLabel) => {
                                                    setValue('supplierId', data ? data.value : null);
                                                }}
                                            />
                                        </FormItem>
                                    </Col>
                                    <Col xs={12} md={6} lg={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('maintenances.included_user_contract_number')}</Label>
                                            <SelectController
                                                form={form}
                                                name="maintenanceContractsId"
                                                placeholder={t('contracts.maintenance_contract.number')}
                                                isDisabled={isDetails && !isModal}
                                                options={contractNumbersOptions}
                                                isClearable={true}
                                                filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                onChangeSelect={(data: SelectValueLabel) => {
                                                    setValue('maintenanceContractsId', data ? data.value : null);
                                                    getVehiclesByContract();
                                                    getValues();
                                                }}
                                            />
                                        </FormItem>
                                    </Col>
                                    {!maintenanceContractId && <>
                                        <Col xs={12} md={6} lg={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('common.cost')}{((!isDetails || isModal) && ((state == VehicleMaintenanceStates.PERFORM) || (form.getValues('state') == VehicleMaintenanceStates.PERFORM))) ? '*' : ''}</Label>
                                                <InputGroupController
                                                    maxLength={255}
                                                    type="number"
                                                    text={t('common.euro')}
                                                    placeholder={t('common.cost')}
                                                    name="cost"
                                                    form={form}
                                                    rules={{ maxLength: 255 }}
                                                    disabled={isDetails && !isModal}
                                                    format="money"
                                                    defaultValue={maintenance?.cost || undefined} />
                                                {form.formState.isSubmitted && (!form.getValues('cost') && !form.getValues('maintenanceContractsId') && ((state == VehicleMaintenanceStates.PERFORM) || (form.getValues('state') == VehicleMaintenanceStates.PERFORM)))
                                                    && <label className={styles.errorLabel}>
                                                        {t('common.errors.required')}
                                                    </label>}
                                            </FormItem>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} className={styles.colXXL}>
                                            <FormItem>
                                                <Label className={styles.label}>
                                                    {t('maintenances.payment_date')}
                                                </Label>
                                                <DateTimePickerControllerNew
                                                    form={form}
                                                    placeholderText={t('common.date')}
                                                    name="paymentDate"
                                                    autoComplete='off'
                                                    disabled={isDetails}
                                                    rules={{ required: false }}
                                                    isClearable={!isDetails}
                                                />
                                                <InputError error={errors.paymentDate} />
                                            </FormItem>
                                        </Col>
                                    </>}

                                    {currentState === VehicleMaintenanceStates.PERFORM && <Col xs={12} md={6} lg={8} xl={6} className={styles.colXXL}>
                                        <FormItem>
                                            <Label className={styles.label}>
                                                {t('maintenances.date_maintenance')} {!isDetails || isModal ? '*' : ''}
                                            </Label>
                                            <DateWithHour
                                                form={form}
                                                datePlaceholder={t('common.date')}
                                                onChangeDate={(date: Date) => {
                                                    setValue('maintenanceDate', date);
                                                    //setMaintenance(maintenance ? { ...maintenance, maintenanceDate: date } : null);
                                                }}
                                                dateSelected={maintenance && maintenance.maintenanceDate ? moment(maintenance.maintenanceDate).toDate() : undefined}
                                                dateFormat={DATE_FORMAT_DEFAUT}
                                                dateCustomInput={<InputGroup icon={<FaCalendarAlt />} removeIconOrTextBorderRadius={true} />}
                                                dateName="maintenanceDate"
                                                dateRequired={true}
                                                dateDisabled={(isDetails && !isModal)}

                                                onTimeChoose={hour => { setValue('maintenanceHour', hour.formatted24) }}
                                                timePlaceholder={t('common.hour')}
                                                timeName="maintenanceHour"
                                                timeDisabled={(isDetails && !isModal)}
                                            />
                                            <InputError error={errors.maintenanceDate || errors.maintenanceHour} />
                                        </FormItem>
                                    </Col>}

                                    {canShowAlertNotifications() && <Col xs={12}>
                                        <Row>
                                            <ReminderTriggerForm form={form}
                                                key={`ReminderTriggerForm_1_${maintenance?.id || 'new'}`}
                                                control={1}
                                                title={t('reminders.notifications.title_maintenance_predicted') as string}
                                                designation={t('maintenances.notices_over_date_end')}
                                                responsablesOptions={responsablesOptions}
                                                measureOptions={measureOptions}
                                                criteriaOptions={criteriaOptions}
                                                isDetails={isDetails}
                                                onCreateResponsableOption={(data: any) => { setResponsablesOptions([...responsablesOptions, { value: data, label: data }]) }}
                                                defaultFirstDate={form.watch('adviseMaintenanceDate')}
                                                defaultFirstKm={form.watch('adviseMaintenanceKilometers')}
                                            />
                                        </Row>
                                    </Col>}



                                    {canShowMaintenanceQuestionArea() && <>
                                    <Col xs={12}><hr className={styles.sectionDivider} /></Col>
                                    <Col xs={12} style={{ marginTop: '0.5rem' }}>
                                        <div className={styles.collapseDivider}>
                                            <span className={styles.collapseDividerText}>
                                                {t('maintenances.program_date_maintenance_question')}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={6} lg={6} xl={4}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('maintenances.affected_to')}</Label>
                                            <SelectController
                                                form={form}
                                                name="responsibleId"
                                                placeholder={t('maintenances.affected_to')}
                                                isDisabled={(isDetails && !isModal) || currentState === VehicleMaintenanceStates.PERFORM}
                                                options={responsibleOptions}
                                                isClearable={true}
                                                filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                onChangeSelect={(data: SelectValueLabel) => {
                                                    setValue('responsibleId', data ? data.value : null);
                                                }}
                                            />
                                        </FormItem>
                                    </Col>
                                    <Col xs={12} md={6} lg={4} xl={3} className={`${styles.colXXL} ${styles.colDateWithHour}`}>
                                        <FormItem>
                                            <Label className={styles.label}>
                                                {t('maintenances.start_date_maintenance')}
                                            </Label>
                                            <DateWithHour
                                                form={form}
                                                datePlaceholder={t('common.date')}
                                                onChangeDate={(date: Date) => {
                                                    setValue('expectedDate', date);
                                                }}
                                                dateSelected={(form.watch('expectedDate')) ? moment(form.getValues('expectedDate')).toDate() : undefined}
                                                dateFormat={DATE_FORMAT_DEFAUT}
                                                dateCustomInput={<InputGroup icon={<FaCalendarAlt />} removeIconOrTextBorderRadius={true} isClearable={true} onClear={() => { setValue('expectedDate', null) }} />}
                                                dateName="expectedDate"
                                                dateRequired={false}
                                                dateDisabled={(isDetails && !isModal) || currentState === VehicleMaintenanceStates.PERFORM}
                                                onTimeChoose={hour => { setValue('expectedHour', hour.formatted24) }}
                                                timePlaceholder={t('common.hour')}
                                                timeName="expectedHour"
                                                timeDisabled={(isDetails && !isModal) || currentState === VehicleMaintenanceStates.PERFORM}
                                            />
                                            <InputError error={errors.expectedDate || errors.expectedHour} />
                                        </FormItem>
                                    </Col>
                                    <Col xs={12} md={6} lg={4} xl={3} className={`${styles.colXXL} ${styles.colDateWithHour}`}>
                                        <FormItem>
                                            <Label className={styles.label}>
                                                {t('maintenances.end_date_maintenance')}
                                            </Label>
                                            <DateWithHour
                                                form={form}
                                                datePlaceholder={t('common.date')}
                                                onChangeDate={(date: Date) => {
                                                    setValue('expectedEndDate', date);
                                                }}
                                                dateSelected={(form.watch('expectedEndDate')) ? moment(form.getValues('expectedEndDate')).toDate() : undefined}
                                                dateFormat={DATE_FORMAT_DEFAUT}
                                                dateCustomInput={<InputGroup icon={<FaCalendarAlt />} removeIconOrTextBorderRadius={true} isClearable={true} onClear={() => { setValue('expectedEndDate', null) }} />}
                                                dateName="expectedEndDate"
                                                dateRequired={false}
                                                dateDisabled={(isDetails && !isModal) || currentState === VehicleMaintenanceStates.PERFORM}
                                                onTimeChoose={hour => { setValue('expectedEndHour', hour.formatted24) }}
                                                timePlaceholder={t('common.hour')}
                                                timeName="expectedEndHour"
                                                timeDisabled={(isDetails && !isModal) || currentState === VehicleMaintenanceStates.PERFORM}
                                                minDate={form.watch('expectedDate') ? moment(form.getValues('expectedDate')).toDate() : undefined}
                                            />
                                            <InputError error={errors.expectedEndDate || errors.expectedEndHour} />
                                        </FormItem>
                                    </Col>
                                    {hasRemindendersCreatePolicy && <Col xs={12}>
                                        <Row>
                                            <ReminderTriggerForm form={form}
                                                key={`ReminderTriggerForm_2_${maintenance?.id || 'new'}`}
                                                control={2}
                                                title={t('reminders.notifications.title_maintenance_appointment') as string}
                                                designation={t('maintenances.notices_over_appointment_date')}
                                                responsablesOptions={responsablesOptions}
                                                measureOptions={measureOptions}
                                                criteriaOptions={criteriaOptions}
                                                isDetails={isDetails}
                                                onCreateResponsableOption={(data: any) => { setResponsablesOptions([...responsablesOptions, { value: data, label: data }]) }}
                                                defaultFirstDate={form.watch('expectedDate')}
                                            />
                                        </Row>
                                    </Col>}
                                    </>}
                                </Row>
                                {renderButtons()}
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={4} xl={3}
                            className={styles.colRightContent}>
                            <div>
                                <Label className={styles.subtitle}>{t('common.attachment')}</Label>
                                <FormItem>
                                    <FileSelector
                                        isDetails={isDetails && !isModal}
                                        isMulti={true}
                                        initialFiles={getValues('attachments')}
                                        onFilesChanged={setValuesFiles}
                                        onRemoveFile={onRemoveFile}
                                        label={<Label className={styles.label}>{t('common.add_new_file')}</Label>}
                                        smallButtonAdd={true}
                                        fileButtonSizes={{ sm: 12, lg: 6 }}
                                    />
                                </FormItem>
                            </div>
                            <div>
                                <FormItem>
                                    <Label className={styles.label}>{t('common.notes')}</Label>
                                    <InputResizable
                                        name="notes"
                                        form={form as any}
                                        disabled={isDetails && !isModal}
                                        defaultValue={maintenance?.notes}
                                        onChange={event => setValue('notes', event.currentTarget.value.toString())}
                                        placeholder={t('common.notes')}
                                        rows={5}
                                    />
                                </FormItem>
                            </div>

                            {sendEmailHistory.length > 0 &&
                                <div>
                                    <Label className={styles.subtitle}>{t('maintenances.email_history')}</Label>

                                    <div className={styles.scrollable}>
                                        <div style={{ display: 'flex', justifyContent: 'left', marginBottom: '1.5rem' }}>
                                            <TimeLine items={sendEmailHistory} emailTemplate={true} />
                                        </div>
                                    </div>

                                </div>}

                            {!isModal && isDetails && hasVehicleMaintenancesWritePolicy && maintenance?.active &&
                                <div className={styles.buttonSend}>
                                    <Button
                                        preset={'primary'}
                                        type="button"
                                        onClick={() => {
                                            setShowSendMaintenanceAttachmentsEmailModal(true);
                                        }}
                                        text={t('maintenances.send_email')}
                                    />
                                </div>
                            }
                        </Col>
                    </Row>
                </div>
            </form >

            {showSendMaintenanceAttachmentsEmailModal && <SendMaintenanceAttachmentsEmailModal
                maintenance={maintenance}
                show={showSendMaintenanceAttachmentsEmailModal}
                onCancel={() => { setShowSendMaintenanceAttachmentsEmailModal(false); getData(); }}
            />}
        </>
    );
}

export default MaintenanceScreen;
